<template>
  <div v-if="!isLoading && !dataLoading" class="container-fluid new_Header">
    <nav class="nav_Breadcrumb"> 
      <ol class="breadcrumb">
        <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('propertielist.breadcrumb_1')}}</router-link></li>
        <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="active mx-3 almarai-bold" aria-current="page">
          {{$t('propertielist.breadcrumb_2')}}
        </li>
      </ol>
    </nav>
  </div>
  <div class="container pt-3">
    <div class="text-center" v-if="isLoading || dataLoading">
      <mainloader />
    </div>
    <div v-else class="row">
      <div class="col">
        <div v-if="hasError">
          <errorAlert :alertMessage="message" :errorNumber='errorNumber' />
        </div>

        <div class="row pt-2">
          <div class="col">
            <nav class="navbar bg-body-tertiary">
              <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-label="Toggle navigation">
                <i class="bi bi-funnel"></i>
              </button>
                <div class="offcanvas offcanvas-start scroll-y" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                  <div class="offcanvas-header">
                    <h5 class="offcanvas-title" id="offcanvasNavbarLabel">{{$t('propertielist.title_1')}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                  </div>
                  <div class="offcanvas-body">
                    <div class="row">
                      <div class="col position-R">
                        <label for="" class="fonttext-14 gray-color almarai-regular pb-2" >{{$t('propertielist.title_2')}}</label>
                        <Select2 
                          class="mouse-hand form-select input-style fonttext-14"
                          v-model="regionId"
                          :placeholder="$t('home.ft_5')"
                          :options="regionsObj"
                          :settings="select2Settings"
                          @select="citiesList()"
                        ></Select2>
                        <!-- <select v-model="regionId" @change="citiesList">
                          <option v-for="(region,index) in regions" :key="index" :value="region.id">{{ region?.name }}</option>
                        </select> -->
                      </div>
                    </div>
                    <div class="row pt-3">
                      <div class="col">
                        <label for="" class="fonttext-14 gray-color almarai-regular pb-2">{{$t('propertielist.title_4')}}</label>
                        <Select2
                          :placeholder="$t('home.ft_6')"
                          class="mouse-hand form-select input-style  fonttext-14"
                          v-model="city"
                          @click.prevent="checkRegions"
                          :options="cityObj"
                          :settings="select2Settings"
                          @select="neighborhoodList()"
                        ></Select2>
                        <!-- <select v-model="city" @change="neighborhoodList" @click.prevent="checkRegions" class="mouse-hand form-select input-style  fonttext-14">
                          <option v-for="(row,index) in rows" :key="index" :value="row.id">{{ row?.name }}</option>
                        </select> -->
                      </div>
                    </div>
                    <div class="row pt-3">
                      <div class="col">
                        <label for="" class="fonttext-14 gray-color almarai-regular pb-2">{{$t('propertielist.title_6')}}</label>
                        <Select2
                          :placeholder="$t('home.ft_6')"
                          class="mouse-hand form-select input-style  fonttext-14"
                          v-model="neighborhood"
                          :options="neighborhoodObj"
                          :settings="select2Settings"
                          @select="checkNeighborhoods()"
                        ></Select2>
                        <!-- <select v-model="neighborhood"  @click.prevent="checkNeighborhoods" class="mouse-hand form-select input-style fonttext-14">
                          <option v-for="(item,indx) in items" :key="indx" :value="item.id">{{item.name}}</option>
                        </select> -->
                      </div>
                    </div>
                    <div class="row pt-3">
                      <label  class="fonttext-14 gray-color almarai-regular">{{$t('propertielist.title_8')}}</label>
                      <div class="col pt-2">
                        <select v-model="propertyType_Id" @change="manageFields" class="mouse-hand form-select input-style  fonttext-14" aria-label="Default select example">
                          <option :value="null" class="fonttext-14">{{$t('propertielist.title_9')}}</option>
                          <option v-for="(val,inde) in typesList" :key="inde" :value="val.id">{{val?.name}}</option>
                        </select>
                      </div>
                    </div>
                      
                    <div class="row pt-4">
                      <span class="fonttext-14 gray-color almarai-regular pb-2">{{$t('propertielist.purpose')}}</span>
                      <div class="col-6 text-center">
                        <label for="sales" class="hand">
                          <div :class="(purpo == 'for_sale') ? 'div-style-filter text-center button-bg' : 'div-style-filter'">
                            <input class="form-check-input d-none form-control" type="radio" v-model="purpo"  value="for_sale" name="flexn" id="sales">
                            <span class="space">{{$t('propertielist.title_11')}}</span>
                          </div>
                        </label>
                      </div>
                      <div class="col-6 text-center">
                        <label for="rent" class="hand">
                          <div :class="(purpo == 'for_rent') ? 'div-style-filter text-center button-bg form-control' : 'div-style-filter form-control'">
                            <input class="form-check-input d-none" type="radio" v-model="purpo"  value="for_rent" name="flexn" id="rent">
                            <span class="space">{{$t('propertielist.title_12')}}</span>
                          </div>
                        </label>
                      </div>
                    </div>

                    <div class="row pt-4 mouse-hand justify-content-center">
                      <span class="fonttext-14 gray-color almarai-regular pb-2">{{$t('propertielist.price')}}</span>
                      <div class="col-6">
                        <input type="text" v-model="priceFrom" class="form-control div-style-filter" :placeholder="$t('propertielist.from')"
                          maxlength="10"  @input="priceFrom = priceFrom.replace(/[^0-9]/g, '')"
                        >
                        <!-- <span class="space">{{}}</span> -->
                      </div>
                      <div class="col-6">
                        <input type="text" v-model="priceTo" class="form-control div-style-filter" :placeholder="$t('propertielist.to')"
                          maxlength="10"  @input="priceTo = priceTo.replace(/[^0-9]/g, '')"
                        >
                        <!-- <span class="space">{{$t('propertielist.to')}}</span> -->
                      </div>
                      <!-- <div class="col-6">
                        <label for="highest">
                          <div :class="(price == 'desc') ? 'div-style-filter button-bg' : 'div-style-filter'">
                            <input type="text" v-model="price" class="form-check-input" value="desc" id="highest">
                            <span class="space">{{$t('propertielist.title_15')}}</span>
                          </div>
                        </label>
                      </div> -->
                    </div>

                    <div class="row pt-4 mouse-hand justify-content-center">
                      <span class="fonttext-14 gray-color almarai-regular pb-2">{{$t('propertielist.area')}} {{$t('areaSymbol')}} </span>
                      <div class="col-6">
                        <!-- <span class="space">{{}}</span> -->
                          <input type="text" v-model="areaFrom" class="form-control div-style-filter" :placeholder="$t('propertielist.from')"
                            maxlength="10"  @input="areaFrom = areaFrom.replace(/[^0-9]/g, '')"
                          >
                      </div>
                      <div class="col-6">
                        <!-- <span class="space">{{}}</span> -->
                          <input type="text" v-model="areaTo" class="form-control div-style-filter" :placeholder="$t('propertielist.to')"
                            maxlength="10"  @input="areaTo = areaTo.replace(/[^0-9]/g, '')"
                          >
                      </div>
                      <!-- <div class="col-6">
                        <label for="highest">
                          <div :class="(price == 'desc') ? 'div-style-filter button-bg' : 'div-style-filter'">
                            <input type="text" v-model="price" class="form-check-input" value="desc" id="highest">
                            <span class="space">{{$t('propertielist.title_15')}}</span>
                          </div>
                        </label>
                      </div> -->
                    </div>

                    <div class="row pt-4 mouse-hand" v-if="showPropertyType">
                      <span class="fonttext-14 gray-color almarai-regular pb-2">{{$t('propertielist.title_16')}}</span>
                      <div class="col-6 text-center">
                        <label for="single" class="hand">
                          <div :class="(propertyTyp == 'singles') ? 'div-style-filter text-center button-bg' : 'div-style-filter text-center'">
                            <input type="radio" v-model="propertyTyp" class="form-check-input d-none" value="singles" id="single">
                            <span>{{$t('propertielist.title_17')}}</span>
                          </div>
                        </label>
                      </div>
                      <div class="col-6 text-center">
                        <label for="familie" class="hand">
                          <div :class="(propertyTyp == 'families') ? 'div-style-filter text-center button-bg' : 'div-style-filter text-center'">
                            <input type="radio" v-model="propertyTyp" value="families" class="form-check-input d-none" id="familie">
                            <span>{{$t('propertielist.title_18')}}</span>
                          </div>
                        </label>
                      </div>
                    </div>

                    <div class="row pt-3" v-if="showRoomsCount">
                      <label  class="fonttext-14 gray-color almarai-regular">{{$t('propertielist.title_19')}}</label>
                      <div class="col pt-2">
                        <input type="number" class="form-control input-style" v-model="roomsCount">
                      </div>
                    </div>

                    <div class="row pt-3" v-if="showFloorNumber">
                      <label  class="fonttext-14 gray-color almarai-regular">{{$t('propertielist.title_20')}}</label>
                      <div class="col pt-2">
                        <input type="number" v-model="floorNumber" class="form-control input-style">
                      </div>
                    </div>

                    <div class="row pt-3" v-if="showAge">
                      <label  class="fonttext-14 gray-color almarai-regular">{{$t('propertielist.title_21')}}</label>
                      <div class="col pt-2">
                        <input type="number" v-model="age" class="form-control input-style">
                      </div>
                    </div>

                    <div class="row pt-5 mouse-hand justify-content-center">
                      <div class="col-6 col-md-6 text-center">
                        <div @click.prevent="viewPropertyList" class="space form-contro  border-0 padding-12 btn-green">
                          {{$t('propertielist.title_22')}}
                        </div>
                      </div>
                      <div class="col-6 col-md-6 text-center">
                        <!-- <div v-if="loadingRemove" class="text-center"> <loader /> </div> -->
                        <div @click.prevent="removeItem" class="rounded-pill form-control padding-12 almarai-bold space border-black">
                          {{$t('propertielist.title_23')}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </nav>
          </div>
        </div>

        <!-- <div class="row pt-3 scroll-row">
          <div class="col-auto mb-3 scroll-col" v-for="(row,indx) in typesList" :key="indx">
            <div @click="setType(row.id)" :class="(propertyType_Id == row.id) ? 'filter-buttons black-button mouse-hand': 'filter-buttons mouse-hand'">
              <img :src="MEDIA_URL+row.icon" class="w-24" alt="">
              <span class="mx-2">{{ row.name }}</span>
            </div>
          </div>
        </div> -->

        <!-- <div class="row">
          <div :class="(category == 'commercial')? 'col-5 col-md-4 categoryStyle balck-bg':'col-5 col-md-4 categoryStyle'">
            <label class="form-check-label mouse-hand" for="commercial">
            <input class="form-check-input" type="radio" name="radioDefault" value="commercial" 
              v-model="category" id="commercial" @change="viewPropertyList"
            >
              <img :src="(category == 'commercial') ?'/assets/images/icons/shop-white.png':'/assets/images/icons/shop.png'" class="max-22" alt="">
              <span class="mx-2">{{$t('commercial')}}</span>
            </label>
          </div>
          <div :class="(category == 'residential')? 'col-5 col-md-4 categoryStyle balck-bg':'col-5 col-md-4 categoryStyle'">
            <label class="form-check-label mouse-hand" for="resident">
            <input class="form-check-input" type="radio" name="radioDefault" value="residential" 
              v-model="category" id="resident" @change="viewPropertyList"
            >
              <img :src="(category == 'residential') ? '/assets/images/icons/building-white.png':'/assets/images/icons/building-4.png'" class="max-22" alt="">
              <span class="mx-2">{{$t('residential')}}</span>
            </label>
          </div>
        </div> -->
        <div class="row scroll-row mb-3">
          <div :class="(category == 'commercial')? 'col-auto categoryStyle balck-bg':'col-auto categoryStyle'">
            <label class="form-check-label mouse-hand" for="commercial">
            <input class="form-check-input" type="radio" name="radioDefault" value="commercial" 
              v-model="category" id="commercial" @change="viewPropertyList"
            >
              <img :src="(category == 'commercial') ?'/assets/images/icons/shop-white.png':'/assets/images/icons/shop.png'" class="max-22" alt="">
              <span class="mx-2">{{$t('commercial')}}</span>
            </label>
          </div>
          <div :class="(category == 'residential')? 'col-auto categoryStyle balck-bg':'col-auto categoryStyle'">
            <label class="form-check-label mouse-hand" for="resident">
            <input class="form-check-input" type="radio" name="radioDefault" value="residential" 
              v-model="category" id="resident" @change="viewPropertyList"
            >
              <img :src="(category == 'residential') ? '/assets/images/icons/building-white.png':'/assets/images/icons/building-4.png'" class="max-22" alt="">
              <span class="mx-2">{{$t('residential')}}</span>
            </label>
          </div>
          <div :class="(purpose == 'for_rent')? 'col-auto category balck-bg':' col-auto category'">
            <label class="form-check-label mouse-hand" for="radioDefault1">
            <input class="form-check-input" type="radio" value="for_rent" 
              v-model="purpose" name="radioDefault" id="radioDefault1" @change="viewPropertyList"
            >
              <span>{{$t("map.btnRent")}}</span>
            </label>
          </div>
          <div :class="(purpose == 'for_sale')? 'col-auto category balck-bg':'col-auto category'">
            <label class="form-check-label mouse-hand" for="radioDefault2">
            <input class="form-check-input" type="radio" name="radioDefault" value="for_sale" 
              v-model="purpose" id="radioDefault2" @change="viewPropertyList"
            >
              <span>{{$t("map.btnSale")}}</span>
            </label>
          </div>
          <div class="col-auto categoryStyle">
            <label class="form-check-label mouse-hand" @click="clearFilter()">
              <span class="mx-2">{{$t("map.btnAll")}}</span>
            </label>
          </div>

          <!-- <div :class="(purpose == 'for_investment')? 'col-auto categoryStyle balck-bg':'col-auto categoryStyle'">
            <label class="form-check-label mouse-hand" for="Investment">
            <input class="form-check-input" type="radio" name="radioDefault" value="for_investment" 
              v-model="purpose" id="Investment" @change="viewPropertyList"
            >
              <span>{{$t("investment")}}</span>
            </label>
          </div> -->
        </div>

        <div class="row scroll-row">
          <div class="col-auto scroll-col" v-for="(row, indx) in typesList" :key="indx">
            <label :for="row.id">
              <div @click="setType(row.id)"
                :class="
                propertyType_Id == row.id
                  ? 'filter-buttons black-button mouse-hand'
                  : 'filter-buttons mouse-hand'
                "
              >
                <span class="showIcon">
                  <img :src="MEDIA_URL + row.icon" class="w-24" alt="" />
                </span>
                <span class="me-2">{{ row?.name }}</span>
                <!-- <input type="radio" class="d-none" v-model="propertyType_Id"  :id="row.id" :value="row.id"> -->
              </div>
            </label>
          </div>
        </div>

        <div class="row" v-if="!isLoading">
          <div class="col-12 col-md-5 col-lg-3 mb-3 p-2" v-for="(val,index) in value.properties" :key="index" >
            <div class="card card-border m-auto" v-if="val.status == 'rented' || val.status == 'sold'">
              <div class="card-body position-R">
                <div class="row reservedProperty"> 
                  <div class="col-auto rented" v-if="val.status == 'rented'">
                    <span>{{$t('rentedOut')}}</span>
                    <img src="/assets/images/icons/key_white.png" class="max-12 mx-1" alt="">
                  </div>
                  <div class="col-auto soldProp" v-if="val.status == 'sold'">
                    <span>{{$t('Sold')}}</span>
                    <img src="/assets/images/icons/key_white.png" class="max-12 mx-1" alt="">
                  </div>
                </div>
                <div class="row statusBar">
                  <div class="col-auto tag-style">
                    <span class="">{{ val.PropertyType?.name }}</span>
                  </div>
                  <div class="col-auto tag-style">
                    <span class="">{{ value.statusChoices[val.status]}}</span>
                  </div>
                </div>
                <!-- <span v-if="val.Favorites && val.Favorites.length" class="heart-icon" @click.prevent="removeFavorite(val.id, 'properties', index)">
                  <i  class="fa-solid fa-heart orange-Heart"></i>
                </span>
                <span v-else class="heart-icon" @click.prevent="addFavorite(val.id, 'properties', index)">
                  <i class="fa-solid fa-heart heart"></i>
                </span> -->
                <swiper v-if="val.mediaFiles.length" class="text-center" 
                  :autoplay="{ delay: 2500, disableOnInteraction: false,}" :modules="modules" 
                  :pagination="{ clickable: true }" :navigation="false"
                >
                  <swiper-slide v-for="(img, ind) in val.mediaFiles" :key="ind">
                    <img :src="MEDIA_URL+img.thumbnail" alt="Slide Image" class="w-100 br-radius" />
                  </swiper-slide>
                </swiper>
                <div v-else>
                  <img src="/assets/images/defaultImage.jpg" class="img-fluid br-radius" alt="">
                </div>
                <div class="text-title">{{ val.title }}</div>
                <div class="row pt-1">
                  <div class="col-auto px-2 content-center">
                    <i class="fa-solid fa-location-dot gray-color"></i>
                  </div>
                  <div class="col p-0 fontGray-73 content-center">
                    <div class="d-flex">
                      {{ val.City?.name }}
                      <span class="mx-1">{{ val.Neighborhood?.name }}</span>
                    </div>
                  </div>
                </div>
                <hr class="border-color-w">
                <div class="row end-card space">
                  <div class="col">
                    <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                    <span class="green-color-F">{{ val.price }}</span>
                  </div>

                  <div class="col-auto content-center" v-if="val.roomsCount && val.bathrooms">
                    <div class="row">
                      <div class="col-auto content-center">
                        <span> 
                          <img :src="MEDIA_URL + value.countedIcons.roomsCount.path" 
                            class="max-width-28"
                            alt=""/>
                        </span>
                        <span class="numbers">{{ val.roomsCount }}</span>
                      </div>
                      <div class="col-auto border_Icons">
                        <span>
                          <img :src="MEDIA_URL + value.countedIcons.bathrooms.path"
                            class="max-width-28"
                            alt=""/>
                        </span>
                        <span class="numbers">{{ val.bathrooms }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-else class="col-auto content-center">
                    <span>
                      <img :src="MEDIA_URL + value.countedIcons.area.path"
                        class="max-width-28"
                        alt=""/>
                    </span>
                    <span class="numbers">
                      {{ val.area }}
                      <span>{{ $t("areaSymbol") }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card-border m-auto" v-if="val.status == 'available'">
              <router-link :to="'/propertydetails/'+val.id">
                <div class="card-body position-R">
                  <div class="row statusBar">
                    <div class="col-auto tag-style">
                      <span class="">{{ val.PropertyType?.name }}</span>
                    </div>
                    <div class="col-auto tag-style">
                      <span class="">{{ value.statusChoices[val.status]}}</span>
                    </div>
                    <div class="col-auto tag-style">
                      <span class="">{{(val.purpose == 'for_rent') ? $t('rent') : (val.purpose == 'for_sale') ? $t('sale')  : $t('investment') }}</span>
                    </div>
                  </div>
                  <span v-if="val.Favorites && val.Favorites.length" class="heart-icon" @click.prevent="removeFavorite(val.id, 'properties', index)">
                    <i  class="fa-solid fa-heart orange-Heart"></i>
                  </span>
                  <span v-else class="heart-icon" @click.prevent="addFavorite(val.id, 'properties', index)">
                    <i class="fa-solid fa-heart heart"></i>
                  </span>
                  <swiper v-if="val.mediaFiles.length" class="text-center" 
                    :autoplay="{ delay: 2500, disableOnInteraction: false,}" :modules="modules" 
                    :pagination="{ clickable: true }" :navigation="false"
                  >
                    <swiper-slide v-for="(img, ind) in val.mediaFiles" :key="ind">
                      <img :src="MEDIA_URL+img.thumbnail" alt="Slide Image" class="w-100 br-radius" />
                    </swiper-slide>
                  </swiper>
                  <div v-else>
                    <img src="/assets/images/defaultImage.jpg" class="img-fluid br-radius" alt="">
                  </div>
                  <div class="text-title">{{ val.title }}</div>
                  <div class="row pt-1">
                    <div class="col-auto px-2 content-center">
                      <i class="fa-solid fa-location-dot gray-color"></i>
                    </div>
                    <div class="col p-0 fontGray-73 content-center">
                      <div class="d-flex">
                        {{ val.City?.name }}
                        <span class="mx-1">{{ val.Neighborhood?.name }}</span>
                      </div>
                    </div>
                  </div>
                  <hr class="border-color-w">
                  <div class="row end-card space">
                    <div class="col">
                      <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                      <span class="green-color-F">{{ val.price }}</span>
                    </div>

                    <div class="col-auto content-center" v-if="val.roomsCount && val.bathrooms">
                      <div class="row">
                        <div class="col-auto content-center">
                          <span> 
                            <img :src="MEDIA_URL + value.countedIcons.roomsCount.path" 
                              class="max-width-28"
                              alt=""/>
                          </span>
                          <span class="numbers">{{ val.roomsCount }}</span>
                        </div>
                        <div class="col-auto border_Icons">
                          <span>
                            <img :src="MEDIA_URL + value.countedIcons.bathrooms.path"
                              class="max-width-28"
                              alt=""/>
                          </span>
                          <span class="numbers">{{ val.bathrooms }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-else class="col-auto content-center">
                      <span>
                        <img :src="MEDIA_URL + value.countedIcons.area.path"
                          class="max-width-28"
                          alt=""/>
                      </span>
                      <span class="numbers">
                        {{ val.area }}
                        <span>{{ $t("areaSymbol") }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>

        <div v-if="!value.properties.length" class="row justify-content-center pt-5">
          <div class="col text-center">
            <div class="row justify-content-center">
              <div class="col-12 col-md-6 mb-3">
                <div class="card border-0 card-h">
                  <div class="card-body text-center">
                    <div><img src="/assets/images/icons/Frame_22.png" class="max-48" alt=""></div>
                    <div class="pt-2 almarai-bold font-22">
                      {{$t('home.title_7')}}
                    </div>
                    <div class="gray-color">{{$t('home.title_8')}}</div>
                    <div v-if="GET_USER" class="pt-3 m-auto w-50">
                      <router-link to="/propertyrequest">
                        <div class="form-control btn-green">{{$t('home.title_9')}}</div>
                      </router-link>
                    </div>
                    <div v-else class="pt-3 m-auto w-50">
                      <div @click="poupLogin" class="form-control btn-green">{{$t('home.title_9')}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row pt-5">
          <div class="col">
            <nav aria-label="Page navigation example">
              <ul class="pagination p-0 justify-content-center mouse-hand">
                <li class="page-item pagination-padding page-link br-radius4" v-if="currentPage > 1"  @click.prevent="prevPage">
                  <i class="fa-solid fa-circle-right orange-color mx-2"></i>
                  <span>{{$t('prev')}}</span>
                </li>
                <li class="page-item pagination-style">{{currentPage}}</li>
                <li class="page-item page-link pagination-padding br-radius4" v-if="value.properties && value.properties.length >= 30"  @click.prevent="nextPage">
                  <span class="mx-2">{{$t('next')}}</span>
                  <i class="fa-solid fa-circle-left orange-color"></i>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <!--begin:modal login-->
    <div class="modal bg-modal" tabindex="-1" id="loginPropertielist">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row">
              <div class="col-auto mouse-hand" @click.prevent="closeingFN">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col text-center">
                <div class="loginTitle">
                  {{$t("formLogin.title_1")}}
                </div>
                <p class="fontGray-73 mb-1 pt-1">
                  {{$t("formLogin.title_2")}} <br />
                  {{$t("formLogin.title_3")}}
                </p>
              </div>
            </div>
            <div class="row pt-3 justify-content-center">
              <div class="col-12 col-md-8 mb-2">
                <router-link to="/login">
                  <button class="form-control btn-green">
                    {{$t("formLogin.title_4")}}
                  </button>
                </router-link>
              </div>
              <div class="col-12 col-md-8 pt-1">
                <router-link to="/register">
                  <button class="form-control btn-black">
                    {{ $t("formLogin.title_5") }}
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:modal Login-->
    <div class="modal bg-modal" id="selectRegion" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <h5 class="modal-title">Modal title</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <img src="/assets/images/icons/Error.png" class="width-48" alt="">
              </div>
            </div>
            <div class="row justify-content-center pt-3">
              <div class="col text-center">
                <p class="mb-1 almarai-bold">{{$t('errorOccurred')}}</p>
                <h6 class="small-Font">{{$t('regionFirst')}}</h6>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-8 text-center mouse-hand text-white">
                <div class="btn-orange" @click="closePopup" >{{$t('continuation')}}</div>
              </div>
            </div>
          </div>
          <!-- <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div> -->
        </div>
      </div>
    </div>

    <div class="modal bg-modal" id="selectNeighborhoods" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <h5 class="modal-title">Modal title</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <img src="/assets/images/icons/Error.png" class="width-48" alt="">
              </div>
            </div>
            <div class="row justify-content-center pt-3">
              <div class="col text-center">
                <p class="mb-1 almarai-bold">{{$t('errorOccurred')}}</p>
                <h6 class="small-Font">{{$t('cityFirst')}}</h6>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-8 text-center mouse-hand text-white">
                <div class="btn-orange" @click="exit" >{{$t('continuation')}}</div>
              </div>
            </div>
          </div>
          <!-- <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Autoplay } from "swiper/modules";

export default {
  name: "propertielist",
  setup() {
    return {
      modules: [Pagination, Navigation, Autoplay]
    };
  },
  data(){
    return{
      propertyType: this.$route.query.propertyType,
      typeId: this.$route.query.typeId,
      regionID: this.$route.query.regionId,
      cityId: this.$route.query.cityId,
      neighborhoodId: this.$route.query.neighborhoodId,
      message: "",
      hasError: false,
      errorNumber: 0,
      isLoading: true,
      loading: true,
      value: {},
      currentPage: 1,
      purpo: "",
      regionId: "",
      city: "",
      neighborhood: "",
      regions: [],
      rows: [],
      items: [],
      typesList: [],
      loader: true,
      propertyType_Id: null,
      dataLoading: true,
      propertyTyp: "",
      age: 0,
      roomsCount: 0,
      floorNumber: 0,
      userLang: 'ar',
      showPropertyType: false,
      showRoomsCount : false,
      showFloorNumber :false,
      showAge: false,
      priceTo: null,
      priceFrom: null,
      areaFrom: null,
      areaTo: null,
      category: "",
      purpose: "",
      regionsObj: [],
      cityObj: [],
      neighborhoodObj: [],
      select2Settings: {
      dropdownParent: '#offcanvasNavbar'
      }
    }
  },
  components: { Swiper, SwiperSlide },
  computed: {
    ...mapGetters(['MEDIA_URL','GET_USER'])
  },
  methods:{
    getDataInit(){
      this.hasError = false;
      this.$http.get("/api/properties/init").then(res => {
        // console.log(res);
        this.regions = res.data.regionsList;
        this.typesList = res.data.typesList;
        let regionArray = [];
        for(let R = 0; R < this.regions.length; R++) {
          regionArray.push({
            id: this.regions[R].id,
            text: this.regions[R].name,
          });
        }
        this.regionsObj = regionArray;
        this.dataLoading = false;  
        window.scroll(0,0);
      }).catch(err => {
        // console.log(err);
        this.dataLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      })
    },

    viewPropertyList(){
      this.hasError = false;
      this.isLoading = true;
      let urlQuery = [`page=${this.currentPage}`];
      if(this.propertyType)
        urlQuery.push('propertyType='+this.propertyType);
      if(this.typeId)
        urlQuery.push('typeId='+this.typeId);
      if(this.neighborhoodId)
        urlQuery.push('neighborhoodId='+this.neighborhoodId);
      if(this.cityId)
        urlQuery.push('cityId='+this.cityId);
      if(this.regionId)
        urlQuery.push(`regionId=${this.regionId}`);
      if(this.regionID && this.regionID != '0')
        urlQuery.push(`regionId=${this.regionID}`);
      if(this.city)
        urlQuery.push(`cityId=${this.city}`);
      if(this.neighborhood)
        urlQuery.push(`neighborhoodId=${this.neighborhood}`);
      if(this.propertyType_Id)
        urlQuery.push(`typeId=${this.propertyType_Id}`);

      if(this.purpo)
        urlQuery.push(`purpose=${this.purpo}`);
      if(this.priceFrom)
        urlQuery.push(`priceFrom=${this.priceFrom}`);
      if(this.priceTo)
        urlQuery.push(`priceTo=${this.priceTo}`);
      if(this.areaFrom)
        urlQuery.push(`areaFrom=${this.areaFrom}`);
      if(this.areaTo)
        urlQuery.push(`areaTo=${this.areaTo}`);
      if(this.category)
        urlQuery.push(`category=${this.category}`);
      if(this.propertyTyp)
        urlQuery.push(`propertyType=${this.propertyTyp}`);
      if(this.purpose)
        urlQuery.push(`purpose=${this.purpose}`);
      this.$http.get("/api/properties/list?"+urlQuery.join('&')).then(res => {
        // console.log(res);
        this.value = res.data;
        this.isLoading = false;
        window.scroll(0,0);
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },
    clearFilter(){
      this.category = "";
      this.purpose = "";
      this.propertyType_Id = null;
      this.viewPropertyList();
    },

    setType(id){
      this.propertyType_Id = id;
      this.viewPropertyList();
    },

    citiesList(){
      this.hasError = false;
      this.city = "";
      this.neighborhood = "";
      this.rows = [];
      this.$http.get("/api/cities/list?regionId="+this.regionId).then(res => {
        // console.log(res);
        this.rows = res.data.cities;
        let cityOptions = [];
        for (let i = 0; i < this.rows.length; i++) {
          cityOptions.push({ id: this.rows[i].id, text: this.rows[i].name });
        }
        this.cityObj = cityOptions;
        this.loading = false;
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    neighborhoodList(){
      this.hasError = false;
      this.neighborhood = "";
      this.items = [];
      this.$http.get("/api/neighborhoods/list?cityId="+this.city).then(res => {
        // console.log(res);
        this.items = res.data.neighborhoods;
        let neighbOptions = [];
        for (let i = 0; i < this.items.length; i++) {
          neighbOptions.push({ id: this.items[i].id, text: this.items[i].name });
        }
        this.neighborhoodObj = neighbOptions;
        this.loader = false;
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    prevPage(){
      this.currentPage -= 1;
      this.viewPropertyList();
    },
    nextPage(){
      this.currentPage += 1;
      this.viewPropertyList();
    },

    removeItem(){
      // this.$router.push({name: 'propertielist'});
      // this.$router.replace({path : '/propertielist'})
      window.location.href = '/propertielist';
    },

    addFavorite(id, dataName, index){
      if(!this.GET_USER){
        document.getElementById('loginPropertielist').style.display = "block";
        return false;
      }
      this.hasError = false;
      this.$http.post("/api/favorites/add",{
        propertyId: id,
      }).then(res => {
        // console.log(res);
        if(dataName == 'properties'){
          this.value.properties[index].Favorites = [{}];
        }
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    removeFavorite(id, dataName, index){
      if(!this.GET_USER){
        document.getElementById('loginPropertielist').style.display = "block";
        return false;
      }
      this.hasError = false;
      this.$http.delete("/api/favorites/remove/"+id).then(res => {
        // console.log(res);
        if(dataName == 'properties'){
          this.value.properties[index].Favorites = [];
        }
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    closeingFN(){
      document.getElementById("loginPropertielist").style.display = "none";
    },

    poupLogin(){
      document.getElementById("loginPropertielist").style.display = "block";
    },

    manageFields(){
      // console.log(this.propertyAdd.typeId);
      this.showPropertyType = false;
      this.showRoomsCount = false;
      this.showFloorNumber = false;
      this.showAge = false;

      // this.showFloorsCount = false;
      // this.showBuildNumber = false;
      // this.showApartmentNumber = false;
      // this.showBathrooms = false;
      // this.showFurnished = false;
      // this.showSaudiBuildingCode = false;
      // this.showPlotNumber = false;
      // this.showHalls = false;

      this.roomsCount = null;
      this.floorNumber = null;
      this.age = null;

      // this.buildNumber = '';
      // this.floorsCount = null;
      // this.apartmentNumber = null;
      // this.bathrooms = null;
      // this.propertyAdd.propertyType = null;
      // this.furnished = null;
      // this.saudiBuildingCode = null;
      // this.plotNumber = "";
      // this.halls = null;

      if(this.propertyType_Id){
        for(let i=0; i < this.typesList.length; i++) {
          if(this.typesList[i].id == this.propertyType_Id) {
            // if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('buildNumber') != -1){
            //   this.showBuildNumber = true;
            // }
              if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('roomsCount') != -1){
                this.showRoomsCount = true;
              }
              if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('floorNumber') != -1){
                this.showFloorNumber = true;
              }
              if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('age') != -1){
                this.showAge = true;
              }

              if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('propertyType') != -1){
              this.showPropertyType = true;
            }

            // if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('floorsCount') != -1){
            //   this.showFloorsCount = true;
            // }
            // if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('apartmentNumber') != -1){
            //   this.showApartmentNumber = true;
            // }
            // if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('bathrooms') != -1){
            //   this.showBathrooms = true;
            // }
            // if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('propertyType') != -1){
            //   this.showPropertyType = true;
            // }
            // if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('furnished') != -1){
            //   this.showFurnished = true;
            // }
            // if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('saudiBuildingCode') != -1){
            //   this.showSaudiBuildingCode = true;
            // }
            // if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('plotNumber') != -1){
            //   this.showPlotNumber = true;
            // }
            // if(this.typesList[i].propertyFields && this.typesList[i].propertyFields.indexOf('halls') != -1){
            //   this.showHalls = true;
            // }
          }
        }
      }
    },

    checkRegions(){
      if(!this.regionId){
        document.getElementById('selectRegion').style.display ='block';
      }
    },

    checkNeighborhoods(){
      if(!this.city){
        document.getElementById('selectNeighborhoods').style.display ='block';
      }
    },

    closePopup(){
      document.getElementById('selectRegion').style.display ='none';
    },
    exit(){
      document.getElementById('selectNeighborhoods').style.display ='none';
    },
    
  },

  // mounted() {
  //   $('#mySelect').select2({
  //     dropdownParent: $('#myOffcanvas')
  //   });
  // },

  created(){
    this.viewPropertyList();
    this.getDataInit();
    this.regionId = parseInt(this.regionID);
    this.city = this.cityId;
    this.neighborhood = this.neighborhoodId;
    this.propertyType_Id = this.typeId;
    if(this.regionId){
      this.citiesList();
    }
    if(this.city){
      this.neighborhoodList();
    }
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  },
}
</script>
